import request from '@/utils/request'

// 获取年度计划列表
export function getAnnualPlans(params) {
  return request({
    url: '/api/annual-plans',
    method: 'get',
    params
  })
}

// 创建年度计划
export function createAnnualPlan(data) {
  return request({
    url: '/move/addTarget',
    method: 'post',
    data
  })
}
export function editAnnualPlan(data) {
  return request({
    url: '/move/editTarget',
    method: 'post',
    data
  })
}
// 获取部门树形数据
// export function getDepartmentTree() {
//     return request({
//       url: '/dept/getDeptList',
//       method: 'get'
//     })
//   }
// 更新年度计划
export function updateAnnualPlan(id, data) {
  return request({
    url: `/api/annual-plans/${id}`,
    method: 'put',
    data
  })
}

// 删除年度计划
export function deleteAnnualPlan(id) {
  return request({
    url: `/api/annual-plans/${id}`,
    method: 'delete'
  })
}

// 获取部门列表
export function getDepartments() {
  return request({
    url: '/dept/getDept',
    method: 'get'
  })
}

// 获取员工列表
export function getEmployees(params) {
  return request({
    url: '/user/getUserList',
    method: 'get',
    params
  })
} 

export function getUserList(params) {
    return request({
      url: `/user/getUserList`,
      method: 'get',
      params
    })
  } 

  export function getTarget(data) {
    return request({
      url: `/move/getTarget`,
      method: 'post',
      data
    })
  } 

// 获取用户年度计划
export function getUserAnnualPlan(params) {
  return request({
    url: '/api/annual-plans/user',
    method: 'get',
    params
  })
} 